export const all = ['cart'] as const
export const details = [...all, 'details'] as const
export const detail = (cartId: string) => [...details, cartId] as const
export const hotelItems = (cartId: string) => [...detail(cartId), 'hotelItems'] as const
